import React from 'react';
import {Box, Title, Text} from '@mantine/core';

type ProfileBioProps = {
    bio: string;
};

export const ProfileBio = ({bio}: ProfileBioProps) => {
    return (
        <Box>
            <Title order={3} size="h5" mb="xs">
                Bio
            </Title>
            <Text size="sm" c="dimmed" style={{maxWidth: '80%'}}>
                {bio}
            </Text>
        </Box>
    );
};
